import { render, staticRenderFns } from "./ListBrands.vue?vue&type=template&id=d18e1cb4&scoped=true"
import script from "./ListBrands.vue?vue&type=script&lang=js"
export * from "./ListBrands.vue?vue&type=script&lang=js"
import style0 from "./ListBrands.vue?vue&type=style&index=0&id=d18e1cb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18e1cb4",
  null
  
)

export default component.exports